import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "13", r: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 9v4l2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 3 2 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 6-3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6.38 18.7 4 21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.64 18.67 20 21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlarmClock";
const AlarmClock = memo(themed(Icon));
export {
  AlarmClock
};
//# sourceMappingURL=alarm-clock.js.map
